import {ChangeDetectorRef, Component} from '@angular/core';
import {Api} from '../../../smoothr-web-app-core/api/api';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {Router} from '@angular/router';
import * as moment from 'moment';
import Order from '../../../smoothr-web-app-core/models/Order';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {Registration} from '../sign-up/sign-up.page';
import {BehaviorSubject} from 'rxjs';
import {numberToCurrency} from 'src/smoothr-web-app-core/utils/utils';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {ShowOrderItemComponent} from 'src/app/components/show-order-item/show-order-item.component';
import {ModalController} from '@ionic/angular';

@Component({
	selector: 'app-my-orders',
	templateUrl: './my-orders.page.html',
	styleUrls: ['my-orders.page.scss']
})
export class MyOrdersPage extends RepositoryDirective {
	regEnum = Registration;
	allOrders: Order[] = [];
	loading = false;
	moment = moment;
	public mode$ = new BehaviorSubject<Registration>(null);
	numberToCurrency = numberToCurrency;
	orderUtils = OrderUtils;
	constructor(
		public repository: RepositoryService,
		private cdr: ChangeDetectorRef,
		private navigationService: NavigationService,
		private modalCtrl: ModalController
	) {
		super(repository);
	}

	// static navigate(router: Router) {
	// 	router.navigateByUrl(MyOrdersPage.url);
	// }

	onCustomer() {
		super.onCustomer();
		this.loadOrders();
	}

	loadOrders() {
		this.allOrders = [];
		this.loading = true;
		if (!this.customer) {
			console.log('user not loaded');
			this.cdr.detectChanges();
			this.loading = false;
			return;
		}
		Api.getCustomerOrders(this.customer.uid)
			.then(res => {
				console.log(res.data);
				this.allOrders = (res.data.withPayment ?? [])
					.sort((a, b) => b.createdAt.valueOf() - a.createdAt.valueOf())
					.reverse();
				this.loading = false;
				this.cdr.detectChanges();
			})
			.catch(err => {
				console.log(err);
				this.loading = false;
				this.cdr.detectChanges();
			});
	}

	async goBack() {
		await this.navigationService.menu();
	}
	async setMode(mode: Registration) {
		if (mode === Registration.SIGN_IN) {
			await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.signUp(), {auth: Registration.SIGN_IN});
		} else {
			await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.signUp(), {auth: Registration.SIGN_UP});
		}
	}
	async showOrder(item: Order) {
		const result = await ShowOrderItemComponent.show(this.modalCtrl, item, this.venue);
	}
}
